import * as React from 'react';
export const rocketSvg = React.forwardRef(function rocketSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.959 5.473a1.013 1.013 0 1 1-1.433-1.432 1.013 1.013 0 0 1 1.433 1.432Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.842 1.742a.75.75 0 0 0-.584-.585c-1.957-.4-4.02-.105-5.548.808a12.33 12.33 0 0 0-1.404.968.76.76 0 0 0-.085.004l-3.223.358a.75.75 0 0 0-.54.33L.591 7.922a.75.75 0 0 0 .442 1.144l2.73.682a.75.75 0 0 0 .135.185l2.168 2.168a.75.75 0 0 0 .185.135l.682 2.73a.75.75 0 0 0 1.144.442l4.297-2.865a.75.75 0 0 0 .33-.541l.357-3.223a.74.74 0 0 0 .005-.085c.335-.417.657-.883.969-1.404.912-1.528 1.206-3.591.806-5.548Zm-6.71 11.827-.384-1.534c1.08-.316 2.092-.705 3.032-1.29a8.95 8.95 0 0 0 .6-.41l-.128 1.154-3.12 2.08ZM3.964 8.252c.316-1.08.705-2.092 1.29-3.032a8.95 8.95 0 0 1 .41-.6l-1.154.128-2.08 3.12 1.534.384Zm5.514-5c1.045-.623 2.5-.902 3.978-.709.193 1.477-.086 2.933-.71 3.978-.855 1.433-1.76 2.326-2.76 2.95-.914.57-1.94.937-3.163 1.265l-1.56-1.56c.328-1.223.695-2.249 1.265-3.162.624-1.002 1.517-1.906 2.95-2.762Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.76 11.03a.75.75 0 0 1 1.06 0l2.15 2.15a.75.75 0 1 1-1.061 1.06L1.76 12.09a.75.75 0 0 1 0-1.06Z',
    }),
  );
});
rocketSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rocket = {
  category: 'icon',
  colorable: true,
  name: 'rocket',
  svg: rocketSvg,
};
